import ChargeHelper from 'features/Charge/chargeHelper';
import { FastField, Formik } from 'formik';
import KTImageInput from 'general/components/OtherKeenComponents/FileUpload/KTImageInput';
import KTFormInput, {
  KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTFormTextArea from 'general/components/OtherKeenComponents/Forms/KTFormTextArea';
import AppColors from 'general/constants/AppColors';
import AppResource from 'general/constants/AppResource';
import miscHelper from 'general/helpers/miscHelper';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useMemo, useRef, useState } from 'react';

DialogAddChargeIdentityPartnerView.propTypes = {
  item: PropTypes.object,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
};

function DialogAddChargeIdentityPartnerView({ item, onCancel, onDone }) {
  const editMode = !!item;
  const [imageSrc, setImageSrc] = useState(null);
  const refFormik = useRef(null);
  const [loading, setLoading] = useState(false);

  const initialFormikValues = useMemo(() => ({
    name: item?.name || '',
    description: item?.description || '',
    website: item?.website || '',
    logo: item?.logo || '',
    address: item?.address || '',
  }), [item]);

  const handleSubmit = async (values) => {
    setLoading(true);
    let param = { ...values };
    delete param.logo;
    if (imageSrc) {
      const res = await miscHelper.callApiUploadFile(imageSrc);
      if (_.isArray(res) && res.length > 0) {
        param.logo = res[0].relativePath;
      }
    }
    param = _.omitBy(param, _.isNil);
    try {
      if (!editMode) {
        const response = await ChargeHelper.API.requestAddChargeIdentityPartner(param);
        if (_.isBoolean(response) && response) {
          ToastHelper.showSuccess('Thêm đối tác sạc thành công');
          if (onDone) onDone();
        } else if (_.isString(response)) {
          ToastHelper.showError(response);
        }
      } else {
        const response = await ChargeHelper.API.requestUpdateChargeIdentityPartner(
          item?.vehicleIdentityPartnerId,
          param
        );
        if (_.isBoolean(response) && response) {
          ToastHelper.showSuccess('Cập nhật đối tác sạc thành công');
          if (onDone) onDone();
        } else if (_.isString(response)) {
          ToastHelper.showError(response);
        }
      }
    } catch (error) {}
    setLoading(false);
  };

  return (
    <div>
      <Formik
        initialValues={initialFormikValues}
        enableReinitialize
        onSubmit={(values) => { handleSubmit(values); }}
        validationSchema={ChargeHelper.ValidationSchema.chargeIdentityPartner}
      >
        {(formikProps) => {
          refFormik.current = formikProps;
          return (
            <div className="d-flex flex-column">
              <div className="row m-0 p-0 px-3 mt-4">
                <div className="col-12 mb-4 px-2">
                  <div className="w-120px">
                    {UIHelper.buildFormLabel('Logo')}
                    <FastField name="logo">
                      {({ field, form, meta }) => (
                        <KTImageInput
                          fullWidth={true}
                          aspectRatio={'1'}
                          name={field.name}
                          editable={true}
                          value={Utils.getFullUrl(field.value)}
                          acceptImageTypes={['image/png', 'image/jpg', 'image/jpeg']}
                          defaultImage={AppResource.images.chargeConnectorTypes.imgChargePointDefault}
                          enableCheckValid
                          onSelectedFile={(file) => {
                            setImageSrc(file);
                            form.setFieldValue(field.name, URL.createObjectURL(file));
                          }}
                          onRemovedFile={() => {
                            setImageSrc(null);
                            form.setFieldValue(field.name, '');
                          }}
                          isValid={_.isEmpty(meta.error)}
                          isTouched={meta.touched}
                          feedbackText={meta.error}
                        />
                      )}
                    </FastField>
                  </div>
                  {UIHelper.buildFormText('Định dạng: JPG, PNG, JPEG')}
                </div>
              </div>
              <div className="row m-0 p-0 px-3">
                <div className="col-6 p-0 px-2 mb-4">
                  {UIHelper.buildFormLabel('Tên đối tác sạc', true)}
                  <FastField name="name">
                    {({ field, form, meta }) => (
                      <KTFormInput
                        type={KTFormInputType.text}
                        placeholder="Nhập tên đối tác"
                        name={field.name}
                        value={field.value}
                        onChange={(value) => { form.setFieldValue(field.name, value); }}
                        onBlur={() => { form.setFieldTouched(field.name, true); }}
                        enableCheckValid={true}
                        isValid={_.isEmpty(meta.error)}
                        isTouched={meta.touched}
                        feedbackText={meta.error}
                      />
                    )}
                  </FastField>
                </div>
                <div className="col-6 p-0 px-2 mb-4">
                  {UIHelper.buildFormLabel('Website')}
                  <FastField name="website">
                    {({ field, form, meta }) => (
                      <KTFormInput
                        type={KTFormInputType.url}
                        placeholder="Nhập website"
                        name={field.name}
                        value={field.value}
                        onChange={(value) => { form.setFieldValue(field.name, value); }}
                        onBlur={() => { form.setFieldTouched(field.name, true); }}
                        enableCheckValid={true}
                        isValid={_.isEmpty(meta.error)}
                        isTouched={meta.touched}
                        feedbackText={meta.error}
                      />
                    )}
                  </FastField>
                </div>
                <div className="col-12 p-0 px-2 mb-4">
                  {UIHelper.buildFormLabel('Địa chỉ')}
                  <FastField name="address">
                    {({ field, form, meta }) => (
                      <KTFormInput
                        type={KTFormInputType.text}
                        placeholder="Nhập địa chỉ cụ thể"
                        name={field.name}
                        value={field.value}
                        onChange={(value) => { form.setFieldValue(field.name, value); }}
                        onBlur={() => { form.setFieldTouched(field.name, true); }}
                        enableCheckValid={true}
                        isValid={_.isEmpty(meta.error)}
                        isTouched={meta.touched}
                        feedbackText={meta.error}
                      />
                    )}
                  </FastField>
                </div>
                <div className="col-12 p-0 px-2 mb-4">
                  {UIHelper.buildFormLabel('Mô tả')}
                  <FastField name="description">
                    {({ field, form, meta }) => (
                      <KTFormTextArea
                        placeholder="Nhập mô tả"
                        rows={3}
                        name={field.name}
                        value={field.value}
                        onChange={(value) => { form.setFieldValue(field.name, value); }}
                        onBlur={() => { form.setFieldTouched(field.name, true); }}
                        enableCheckValid={true}
                        isValid={_.isEmpty(meta.error)}
                        isTouched={meta.touched}
                        feedbackText={meta.error}
                      />
                    )}
                  </FastField>
                </div>
              </div>
            </div>
          );
        }}
      </Formik>

      <div
        className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
        style={{ borderTop: `1px solid ${AppColors.gray[200]}` }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
        {UIHelper.buildGreenButton(
          !editMode ? 'Thêm' : 'Cập nhật',
          () => { refFormik.current.handleSubmit(); },
          null,
          false,
          loading
        )}
      </div>
    </div>
  );
}

export default DialogAddChargeIdentityPartnerView;
